import React from 'react';

/**
 * SignatureUploader — small file-picker that reads a PNG/JPG into a base64
 * data URL and emits it via onChange. Used in the User create/edit forms so
 * each user can attach their digital signature, which is then rendered on
 * printed PO / PE / DN / Invoice documents above the "Prepared by" /
 * "Approved by" signature lines.
 */
export default function SignatureUploader({ value, onChange, label = 'Digital Signature', testIdPrefix = 'user-signature' }) {
  const handleFile = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (file.size > 2 * 1024 * 1024) {
      alert('Signature image must be 2 MB or smaller.');
      return;
    }
    const reader = new FileReader();
    reader.onload = () => onChange(reader.result);
    reader.readAsDataURL(file);
  };

  return (
    <div className="md:col-span-2">
      <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>
      <p className="text-xs text-gray-500 mb-2">
        PNG / JPG with transparent background recommended. Shown above the
        signature line on Purchase Orders, Purchase Entries, Delivery Notes,
        and Sales Invoices when this user is the Prepared-by or Approved-by.
      </p>
      <div className="flex items-center gap-3 flex-wrap">
        {value ? (
          <div
            className="border rounded bg-white p-2"
            style={{ width: 180, height: 70, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
            data-testid={`${testIdPrefix}-preview`}
          >
            <img
              src={value}
              alt="Signature"
              style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
            />
          </div>
        ) : (
          <div
            className="border rounded bg-gray-50 text-xs text-gray-400 italic"
            style={{ width: 180, height: 70, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          >
            No signature uploaded
          </div>
        )}
        <input
          type="file"
          accept="image/png,image/jpeg,image/jpg"
          onChange={handleFile}
          data-testid={`${testIdPrefix}-input`}
          className="text-sm"
        />
        {value && (
          <button
            type="button"
            onClick={() => onChange('')}
            className="text-xs text-red-600 underline"
            data-testid={`${testIdPrefix}-remove`}
          >
            Remove
          </button>
        )}
      </div>
    </div>
  );
}
